import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {  ADD_SUPPORT_DETAILS_REQUEST, DELETE_SUPPORT_DETAILS_REQUEST, GET_SUPPORT_DETAILS_LIST_REQUEST } from "./type";
import { addSupportDetailsSuccess, deleteSupportDetailsSuccess, getSupportDetailsListRequest, getSupportDetailsListSuccess } from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";


function* SupportDetailsList({ payload: data }) {
    try {
        const res = yield call(invokeApi, "post", "/supportList", data);
        if (res.status) {
            yield put(getSupportDetailsListSuccess(res.data));
        } else {
            yield put(getSupportDetailsListSuccess([]));
            ApiResponseMessage(res.message, DANGER);
            handleApiCallException(res.message)
        }
    } catch (error) {
        ApiResponseMessage(error, DANGER);
        handleApiCallException(error)
    }
}

function* addSupportDetails({ payload: data }) {
    try {
        const res = yield call(invokeApi, "post", "/createSupportDetails", data.value);
        if (res.status) {
            ApiResponseMessage(res.message, SUCCESS)
            yield put(addSupportDetailsSuccess(res));
            yield put(getSupportDetailsListRequest(data.dispatch))
        } else {
            yield put(addSupportDetailsSuccess(res));
            ApiResponseMessage(res.message, DANGER);
            handleApiCallException(res.message)
        }
    } catch (error) {
        ApiResponseMessage(error, DANGER);
        handleApiCallException(error)
    }
}
function* deleteSupport({ payload: data }) {
   
    try {
        const res = yield call(invokeApi, "put", "/deleteSupportDetails", data.value);
        if (res.status) {
            yield put(deleteSupportDetailsSuccess(res));
            ApiResponseMessage(res.message, SUCCESS)
            yield put(getSupportDetailsListRequest(data.dispatchData))
        } else {
            yield put(deleteSupportDetailsSuccess(res));
            ApiResponseMessage(res.message, DANGER);
            handleApiCallException(res.message)
        }
    } catch (error) {
        ApiResponseMessage(error, DANGER);
        handleApiCallException(error)

    }
}

function* watchSupportRequest() {
    yield takeLatest(GET_SUPPORT_DETAILS_LIST_REQUEST, SupportDetailsList);
    yield takeLatest(ADD_SUPPORT_DETAILS_REQUEST, addSupportDetails);
    yield takeLatest(DELETE_SUPPORT_DETAILS_REQUEST, deleteSupport);
}

function* SupportDetailsSaga() {
    yield all([fork(watchSupportRequest)]);
}

export default SupportDetailsSaga;
